import { render, staticRenderFns } from "./BISummary.vue?vue&type=template&id=9de5d4aa"
import script from "./BISummary.vue?vue&type=script&lang=js"
export * from "./BISummary.vue?vue&type=script&lang=js"
import style0 from "./BISummary.vue?vue&type=style&index=0&id=9de5d4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports